import React, { useState, useContext, useEffect, useRef } from 'react';
import styled from 'styled-components/macro';
import { palette, IconArrowRight, zIndex, IconHelp, CloseButton, fontDefault } from '@mirinae/react-ui';
import { os } from '@mirinae/js-utils/utils/userAgent';
import PlayerContext from '@mirinae/lessons/modules/contexts/player';

const BubbleContent = styled.div`
    padding: 7px 12px 7px 12px;
    background-color: white;
    border-radius: 15px;
    box-shadow: rgb(159, 188, 186) 4px 2px 16px 0px, rgb(255, 255, 255) -4px -2px 16px 0px;
//    box-shadow: rgb(200,200,200) 4px 2px 16px 0px,rgb(255,255,255) -4px -2px 16px 0px;
    border: 2px solid rgba(255,255,255,0.3);
    margin: 7px 0;
    white-space: pre-line;
    font-family: ${fontDefault},sans-serif;
    font-size: 11px;
    font-weight: 500;
    color: rgb(60,60,59);
  
    p + p {
       display: block;
       margin: 10px 0 0 0;
    }
`;

const BubbleTitle = styled.div`
    background-color: white;
    border-radius: 15px;
    padding: 1px 0;
    box-shadow: rgb(159, 188, 186) 4px 2px 16px 0px, rgb(255, 255, 255) -4px -2px 16px 0px;
    // box-shadow: rgb(200,200,200) 4px 2px 16px 0px,rgb(255,255,255) -4px -2px 16px 0px;
    border: 2px solid rgba(255,255,255,0.3);
    font-family: Montserrat,sans-serif;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    display: inline-flex;
    color: rgb(60,60,59);
    align-items: center; 
    width: max-content;
    align-self: ${props => (props.arrowPos === 'right' ? 'flex-end' : 'flex-start')};
`;

const Arrow = ({ color, angle }) => <IconArrowRight color={color} style={{ transform: `scale(0.8) rotate(${angle}deg)`, margin: '0 9px' }} />;

const arrowAngle = { up: 270, down: 90, right: 0, left: 180 };

const Expander = styled.span`
    padding: 0 7px;
`;

const BubbleContainer = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    justify-content: flex-end;
    z-index: ${zIndex.tutorial};
`;


const helpRegistry = {};

export const registerHelp = (components, help) => {
    return; // disabled for Mirinae 1.0 todo: we should remove all the help-bubble related code code
    // (Array.isArray(components) ? components : [components]).forEach(component => {
    //     helpRegistry[typeof component === 'string' ? component : component.name] = Array.isArray(help) ? help : [help];
    // });
};

export const HelpBubble = ({ content, title, desktop, mobile, tag, children }) => {
    const [show, setShow] = useState(false);
    const [showContent, setShowContent] = useState(false);
    const [bubbleRef, setBubbleRef] = useState(null);
    const { titleAt, arrowPos, arrowDir, anchor, style: styleProp } = os.isOthers ? desktop : mobile;
    const [style, setStyle] = useState({ ...styleProp }); // copy, follow local overrides
    const flag = useRef(null);

    useEffect(() => {
        if (anchor) {
            const anchorEl = document.querySelector(anchor);
            if (anchorEl && getComputedStyle(anchorEl).display !== 'none') {
                flag.current = `${tag}-${anchor}`;
            }
        } else {
            flag.current = tag;
        }
        if (flag.current && localStorage.getItem(flag.current) !== 'help-seen') {
            setShow(true);
            localStorage.setItem(flag.current, 'help-seen');
        }
    }, []);

    const closeBubble = () => {
        setShow(false);
        localStorage.setItem(flag.current, 'help-seen');
    };

    useEffect(() => {
        if (anchor && bubbleRef) {
            const anchorEl = document.querySelector(anchor);
            if (anchorEl && getComputedStyle(anchorEl).display !== 'none') {
                // make positions anchor-relative, if provided
                const anchorRect = anchorEl.getBoundingClientRect();
                const bubbleOffsetParentRect = bubbleRef.offsetParent.getBoundingClientRect();
                const dl = bubbleOffsetParentRect.left - anchorRect.left;
                const dt = bubbleOffsetParentRect.top - anchorRect.top;
                const dr = bubbleOffsetParentRect.right - anchorRect.right;
                const db = bubbleOffsetParentRect.bottom - anchorRect.bottom;
                const anchorRelStyle = { ...style };
                if (style.left !== undefined) anchorRelStyle.left -= dl;
                if (style.right !== undefined) anchorRelStyle.right += dr;
                if (style.top !== undefined) anchorRelStyle.top -= dt;
                if (style.bottom !== undefined) anchorRelStyle.bottom += db;
                setStyle(anchorRelStyle);

                anchorEl.addEventListener('click', closeBubble);
                anchorEl.addEventListener('touchstart', closeBubble);
                return () => { anchorEl.removeEventListener('click', closeBubble); anchorEl.removeEventListener('touchstart', closeBubble); };
            }
        }
    }, [bubbleRef]);

    return show && (
        <BubbleContainer ref={ref => setBubbleRef(ref)} style={style}>
            { titleAt === 'top' ? (
                <>
                    { title && (
                        <BubbleTitle arrowPos={arrowPos}>
                            { arrowPos === 'right' && <CloseButton onClick={closeBubble} width={7} height={7} /> }
                            { arrowPos === 'left' && <Arrow color={palette.point.red} angle={arrowAngle[arrowDir]} /> }
                            {title}
                            <Expander onClick={() => setShowContent(!showContent)}><IconHelp /></Expander>
                            { arrowPos === 'right' && <Arrow color={palette.point.red} angle={arrowAngle[arrowDir]} /> }
                            { arrowPos === 'left' && <CloseButton onClick={closeBubble} width={7} height={7} /> }
                        </BubbleTitle>
                    )}
                    { showContent && <BubbleContent style={{ width: style.contentWidth }}>{content || children}</BubbleContent> }
                    {/* <HelpBubbleControls /> */}
                </>
            ) : (
                <>
                    {/* <HelpBubbleControls /> */}
                    { showContent && <BubbleContent style={{ width: style.contentWidth }}>{content || children}</BubbleContent> }
                    { title && (
                        <BubbleTitle arrowPos={arrowPos}>
                            { arrowPos === 'right' && <CloseButton onClick={closeBubble} width={7} height={7} /> }
                            { arrowPos === 'left' && <Arrow color={palette.point.red} angle={arrowAngle[arrowDir]} /> }
                            {title}
                            <Expander onClick={() => setShowContent(!showContent)}><IconHelp /></Expander>
                            { arrowPos === 'right' && <Arrow color={palette.point.red} angle={arrowAngle[arrowDir]} /> }
                            { arrowPos === 'left' && <CloseButton onClick={closeBubble} width={7} height={7} /> }
                        </BubbleTitle>
                    )}
                </>
            )}
        </BubbleContainer>
    );
};

const BUBBLES_TO_SHOW_PER_PAGE = 3;

export const PageHelp = ({ page }) => {
    const player = useContext(PlayerContext);
    const [helpBubbles, setHelpBubbles] = useState([]);

    useEffect(() => {
        // gather help bubbles for this page, including elements on page current step & page itself
        const help = [];
        player.currentStep.children.concat([page]).forEach(c => {
            let cname = c.componentName;
            let ch = helpRegistry[cname];
            if (!ch) {
                cname = c.nodeClass === 'page' ? player.componentMap.getPageComponent(c).name : player.componentMap.getElementComponent(c).name;
                ch = helpRegistry[cname];
            }
            if (ch) {
                ch.forEach((h, i) => {
                    if ((os.isOthers && h.props.desktop) || (!os.isOthers && h.props.mobile)) {
                        const tag = `${cname}.${i}`;
                        help.push(React.cloneElement(h, { key: help.length, tag }));
                    }
                });
            }
        });
        setHelpBubbles(help);
    }, [page]);

    return helpBubbles;
};
